// Components/ChatContacts/hooks/useContactsObserver.js
import { useRef } from "react";

export const useContactsObserver = (
    filteredContacts,
    listRef,
    contactRefs
) => {
    // Mantenemos la referencia para compatibilidad con componentes que la usan
    const observerRef = useRef(null);
    
    // No hacemos nada con el observer, ya que no necesitamos lazy loading
    // Simplemente devolvemos la referencia para mantener la compatibilidad
    return observerRef;
};